import {
  ButtonDS,
  CheckboxAtom,
  GlobalIcon,
  Typography,
} from "get-life-storybook-ts";
import { getMessage } from "../PaymentCardContent/PaymentCardContent.component";
import PDFViewer from "../PDF/PDFViewer";
import CheckoutPayController from "./CheckoutPay.controller";
import ProposalFailureDialog, { citiesCategory } from "./ProposalFailureDialog";
import LegalNoteRejectionDialog from "./LegalNoteRejectionDialog";
import "./checkOutPay.scss";

const CheckoutPay = () => {
  const {
    activeButton,
    confirmed,
    handleChangeConfirmed,
    handleRequest,
    note,
    noteUrl,
    translate,
    userAcceptance,
    setUserAcceptance,
    userHasConditionsToAccept,
    domain,
    proposalFailure,
    anagraphic,
    saveAnagraphicAndRetry,
    retryProposal,
    closeProposalFailure,
    leadRepository,
    legalNoteRejected,
    closeLegalNoteRejected,
  } = CheckoutPayController();
  const messageWarning = getMessage({
    message: translate("informativeNote.warning"),
    replace: <b>{translate("informativeNote.buttonSignText")}</b>,
  });

  return (
    <div className="checkoutPay-bodyContainer">
      <div className="checkoutPay-noteContainer">
        <Typography
          text={translate("informativeNote.title")}
          variant="H2"
          weight="700"
          className="text-[#424242]"
        />
        <p className="checkoutPay--subtitle">
          <GlobalIcon
            iconName="InfoIcon"
            size="XXS"
            color="var(--theme-primary)"
            className="checkoutPay--infoIcon"
          />
          <Typography
            text={translate("informativeNote.subtitle")}
            variant="BodyMedium"
            weight="500"
          />
        </p>
        {note && <PDFViewer url={note} translate={translate} />}
      </div>
      <div className="checkoutPay-buttonContainer">
        {userHasConditionsToAccept ? (
          <div className="checkoutPay-checkboxes">
            <CheckboxAtom
              labelTitle={
                <span
                  dangerouslySetInnerHTML={{
                    __html: translate("informativeNote.privacyPolicies"),
                  }}
                />
              }
              isLegal={true}
              checked={userAcceptance.privacyPolicies}
              onValueChange={(value) =>
                setUserAcceptance({ ...userAcceptance, privacyPolicies: value })
              }
            />
            <CheckboxAtom
              labelTitle={
                <span
                  dangerouslySetInnerHTML={{
                    __html: translate("informativeNote.personalData"),
                  }}
                />
              }
              isLegal={true}
              checked={userAcceptance.personalData}
              onValueChange={(value) =>
                setUserAcceptance({ ...userAcceptance, personalData: value })
              }
            />
            <CheckboxAtom
              labelTitle={
                <span
                  dangerouslySetInnerHTML={{
                    __html: translate("informativeNote.conditions"),
                  }}
                />
              }
              isLegal={true}
              checked={userAcceptance.conditions}
              onValueChange={(value) =>
                setUserAcceptance({ ...userAcceptance, conditions: value })
              }
            />
          </div>
        ) : null}
        <div className="checkoutPay-innerButtonContainer">
          { domain !== "fr" && <ButtonDS
            label={translate("informativeNote.buttonSign")}
            disabled={!activeButton}
            onClick={handleRequest}
            className="w-full"
            rightIcon="ArrowRightIcon"
          />}
          {noteUrl !== null && (
            // content_opened (telemetría): el cliente abre el PDF de la nota legal.
            <span data-track="legal_note_pdf" style={{ display: "contents" }}>
              <ButtonDS
                href={noteUrl!}
                rel="noreferrer"
                target="_blank"
                leftIcon="FileDownload"
                buttonType="secondary"
                label={translate("informativeNote.downloadPdf")}
                className="w-full"
              />
            </span>
          )}
        </div>
        <div className="checkoutPay-messages">
          <span>{messageWarning}</span>
          <p>{translate("informativeNote.extraPhrase")}</p>
        </div>
      </div>
      {null !== proposalFailure && (
        <ProposalFailureDialog
          kind={proposalFailure}
          anagraphic={anagraphic}
          translate={translate}
          onSave={saveAnagraphicAndRetry}
          onRetry={retryProposal}
          onClose={closeProposalFailure}
          loadCities={() => leadRepository.getQuestionNomenclator(citiesCategory())}
        />
      )}
      {null !== legalNoteRejected && (
        <LegalNoteRejectionDialog
          rejection={legalNoteRejected}
          translate={translate}
          onClose={closeLegalNoteRejected}
        />
      )}
    </div>
  );
};

export default CheckoutPay;
